interface BurgerMenuProps {
  className?: string;
  onClick?: () => void;
}

export const BurgerMenu = ({ className = "", onClick }: BurgerMenuProps): JSX.Element => {
  return (
    <button
      onClick={onClick}
      className={`flex flex-col justify-center items-center gap-1.5 ${className}`}
      aria-label="Menu"
    >
      <span className="w-6 h-0.5 bg-[var(--fy-grey)] rounded-full transition-all"></span>
      <span className="w-6 h-0.5 bg-[var(--fy-grey)] rounded-full transition-all"></span>
      <span className="w-6 h-0.5 bg-[var(--fy-grey)] rounded-full transition-all"></span>
    </button>
  );
};